// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"367":"b4e9c58e1a7d6d44","2888":"ea0ac74ead5a84fe","4793":"982a2a40a0080442"}[chunkId] + ".css";
};